import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-linktree', 'IconBrandLinktree', [
  ['path', { d: 'M9 3l-7 12h3v5h5v-5h-2l4 -7z', key: 'svg-0' }],
  ['path', { d: 'M15 3l7 12h-3v5h-5v-5h2l-4 -7z', key: 'svg-1' }],
]);
